<template>
  <router-view/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModalBus from '../../event-bus/modal-bus';
import SubscriptionCtaPopup from '../../pages/responsive-pages/authenticated/trial/SubscriptionCtaPopup.vue';

export default {
  name: 'PoupupManager',
  props: {
    hideCta: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    this.startLoading(this.$options.name);
    await this.initSubscriptionState();
    await this.initSavingsChallenge();
    await this.initPromotions();
    this.doneLoading(this.$options.name);

    if (this.shouldShowCta && !this.hideCta) {
      ModalBus.$emit('open', {
        component: SubscriptionCtaPopup,
      });
      return;
    }

    if (this.shouldShowChallenge) {
      ModalBus.$emit('open', {
        component: this.variantComponent,
      });
    }
  },
  computed: {
    ...mapGetters('subscriptionState', ['shouldShowCta']),
    ...mapGetters('savingsChallenge', ['shouldShowChallenge', 'variantComponent']),
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
    ...mapActions('subscriptionState', ['initSubscriptionState']),
    ...mapActions('savingsChallenge', ['initSavingsChallenge']),
    ...mapActions('promotions', ['initPromotions']),
  },
};
</script>



// WEBPACK FOOTER //
// src/base-components/app-header/PopupsManager.vue